import { render, staticRenderFns } from "./le-select-local-search.vue?vue&type=template&id=244af8fa&"
import script from "./le-select-local-search.vue?vue&type=script&lang=js&"
export * from "./le-select-local-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports